import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';

import type { UseQuery, QueryResult } from '../../../types';

export type Account = {
  id: number;
  normalizedImageUrl: string;
  normalizedName: string;
};

export type AccountsResponse = {
  accounts: Array<Account>;
  currentUserV2: {
    id: string;
    email: string;
  };
};

type Result = QueryResult<AccountsResponse>;

export const accountsDataQuery: DocumentNode = gql`
  query accountsDataQuery {
    accounts {
      id
      normalizedImageUrl
      normalizedName
    }
    currentUserV2 {
      id
      email
    }
  }
`;

/**
 * Hook that provides data used for the accounts menu inside global navigation.
 */
const useAccountsMenuData = ({ useQuery }: { useQuery: UseQuery }): Result =>
  // The fetchPolicy is explicitly set here because any page querying for account data
  // with this fetchPolicy will not render the header correctly.
  // Example: `usePlans` on `/companies`
  useQuery(accountsDataQuery, { ssr: false, fetchPolicy: 'network-only' });

export default useAccountsMenuData;
